import { Navigate, type RouteObject } from 'react-router-dom';

import { AttractScreen } from './screens/Attract';
import { BrowseScreen } from './screens/Browse';
import { CheckInScreen } from './screens/CheckIn';
import { DeliveryInvoiceScreen } from './screens/DeliveryInvoice';
import { DeviceSetupScreen } from './screens/DeviceSetup';
import { HomeScreen } from './screens/Home';
import { IssueSuccessScreen } from './screens/IssueSuccess';
import { LanguageScreen } from './screens/Language';
import { PaymentProgressScreen } from './screens/PaymentProgress';
import { PaymentSelectScreen } from './screens/PaymentSelect';
import { PlanScheduleScreen } from './screens/PlanSchedule';
import { RecommendScreen } from './screens/Recommend';
import { RecommendResultScreen } from './screens/RecommendResult';
import { ScheduleScreen } from './screens/Schedule';
import { SpotsScreen } from './screens/Spots';
import { VoiceScreen } from './screens/Voice';

/**
 * KIOSK 購票線性動線（對應 docs/Kiosk_UI_Flow.md 全域 Sitemap）：
 *   Attract → 語言 → 首頁 → (智慧推薦 | 自己選) → 班次+人數（套票／多商品行程走 /plan 逐段選）
 *           → 收票方式 → 發票 → 付款方式 → 付款進行中 → 出票完成
 */
export const routes: RouteObject[] = [
  { path: '/', element: <AttractScreen /> },
  { path: '/language', element: <LanguageScreen /> },
  { path: '/home', element: <HomeScreen /> },
  { path: '/recommend', element: <RecommendScreen /> },
  { path: '/recommend/result', element: <RecommendResultScreen /> },
  { path: '/browse', element: <BrowseScreen /> },
  { path: '/checkin', element: <CheckInScreen /> },
  { path: '/voice', element: <VoiceScreen /> },
  { path: '/spots', element: <SpotsScreen /> },
  { path: '/device-setup', element: <DeviceSetupScreen /> },
  { path: '/schedule', element: <ScheduleScreen /> },
  // 套票與多商品行程走逐段選時段（見 PlanSchedule）
  { path: '/plan', element: <PlanScheduleScreen /> },
  { path: '/delivery', element: <DeliveryInvoiceScreen /> },
  { path: '/payment', element: <PaymentSelectScreen /> },
  { path: '/paying', element: <PaymentProgressScreen /> },
  { path: '/done', element: <IssueSuccessScreen /> },
  { path: '*', element: <Navigate to="/" replace /> },
];
